import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ContextInfoBannerProps = {
    consultationId?: string
    expertiseId?: string
}

export function ContextInfoBanner({ consultationId, expertiseId }: ContextInfoBannerProps) {
    const { t } = useTranslation()

    return (
        <Box sx={{ p: 1, bgcolor: 'info.light', borderRadius: 1, opacity: 0.8 }}>
            <Typography variant="caption" color="info.contrastText">
                {consultationId && t('medicalAct.record.linkedToConsultation', { defaultValue: 'This act will be linked to the current consultation' })}
                {expertiseId && t('medicalAct.record.linkedToExpertise', { defaultValue: 'This act will be linked to the current expertise' })}
                {!consultationId && !expertiseId && t('medicalAct.record.standalone', { defaultValue: 'This act will be recorded as a standalone act' })}
            </Typography>
        </Box>
    )
}
